const _excluded = ["children", "info", "as", "className", "statusType", "size"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import cn from 'classnames';
import { Tooltip, Typography } from "../../index";
import styles from "./WithStatusIcon.module.scss";
import { InfoFill24, InfoFill } from "../../icons";

/**
 * Adds an error icon with info after the content. Used for decorating a text section
 * with an error icon.
 */
export function WithStatusIcon(props) {
  const {
    children,
    info,
    as,
    className,
    statusType = 'error',
    size = 'small'
  } = props,
        rest = _objectWithoutProperties(props, _excluded);

  const RootElement = as || 'div';
  return /*#__PURE__*/React.createElement(RootElement, _extends({}, rest, {
    className: cn(styles.root, className)
  }), children, /*#__PURE__*/React.createElement(Tooltip, {
    placement: "top",
    title: info
  }, /*#__PURE__*/React.createElement(Typography, {
    skin: statusType
  }, size === 'small' && /*#__PURE__*/React.createElement(InfoFill24, null), size === 'medium' && /*#__PURE__*/React.createElement(InfoFill, null))));
}